<template>
  <show-goods-table :goods-list="goodsList" class="goods-show-list">
    <template>
      <el-table-column label="商品规格">
        <template slot-scope="scope">
          {{scope.row.specifications.name}}
        </template>
      </el-table-column>
      <template v-if="promotionData.promotionType==='SNAP_UP'">
        <el-table-column label="秒杀设置">
          <template slot-scope="scope">
            {{scope.row.snapUp_price+'元/'+scope.row.amount+'份'}}
          </template>
        </el-table-column>
      </template>
      <template v-else-if="promotionData.promotionType==='TIME_LIMIT_DISCOUNT'">
        <el-table-column label="折扣">
          <template slot-scope="scope">
            {{scope.row.discount_discount_show}}
          </template>
        </el-table-column>
        <el-table-column label="活动价(元)">
          <template slot-scope="scope">
            {{scope.row.promotional_price}}
          </template>
        </el-table-column>
        <el-table-column label="是否参加满减活动" v-if="fullReductionDiscount&&fullReductionDiscount.openFullReduction">
          <template slot-scope="scope">
            {{scope.row.useFullReduction?'是':"否"}}
          </template>
        </el-table-column>
      </template>
      <template v-else-if="promotionData.promotionType==='CASH_BACK'">
        <el-table-column label="活动价(元)">
          <template slot-scope="scope">
            {{scope.row.discount_show}}
          </template>
        </el-table-column>
        <el-table-column label="折扣">
          <template slot-scope="scope">
            {{scope.row.discount_discount_show}}
          </template>
        </el-table-column>
        <el-table-column label="购买者返现金额">
          <template slot-scope="scope">
            {{scope.row.buyer_cashBack}}
          </template>
        </el-table-column>
        <el-table-column label="分享者返现金额">
          <template slot-scope="scope">
            {{scope.row.sharer_cashBack}}
          </template>
        </el-table-column>
      </template>
    </template>
  </show-goods-table>
</template>
<script>
import showGoodsTable from '../../pt-promotion-coupon/show-goods-table'
export default {
  components: {
    showGoodsTable
  },
  props: {
    goodsList: {
      type: Array,
      default: function () {
        return []
      }
    },
    promotionData: {
      type: Object,
      default: function () {
        return {}
      }
    },
    fullReductionDiscount: {
      type: Object,
      default: function () {
        return {}
      }
    }
  }
}
</script>
<style lang="less">
.goods-show-list{
        .el-table{
            thead{
                th{
                color: #909399!important
                }
            }
            tr{
        display: table-row!important;
                td{
                    &>div{
                    color:#606266!important

                    }
                }
            }
        }
    }
</style>
